var _excluded = ["innerHeight", "innerWidth", "height", "width"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var keys = function keys(main) {
  var allKeys = ["", "V", "H", "Left", "Right", "Top", "Bottom"];
  return allKeys.map(function (d) {
    return main + d;
  });
};

var keyRemover = function keyRemover(type) {
  return function (obj) {
    var o1 = obj;

    var _iterator = _createForOfIteratorHelper(keys(type)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        delete o1[key];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return o1;
  };
};

var removeMargin = keyRemover("margin");
var removePadding = keyRemover("padding");

var extractMargin = function extractMargin(obj) {
  var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  /*
  I'm really annoyed I can't find a third-party implementation
  of this that covers edge cases...
  This eventually is useful for a React version of the SVG "margin convention"
  https://bl.ocks.org/mbostock/3019563
  */
  var marginLeft = obj.marginLeft,
      marginRight = obj.marginRight,
      marginTop = obj.marginTop,
      marginBottom = obj.marginBottom,
      marginV = obj.marginV,
      marginH = obj.marginH,
      margin = obj.margin;

  if (margin == null) {
    margin = 0;
  }

  if (marginV == null) {
    marginV = margin;
  }

  if (marginH == null) {
    marginH = margin;
  }

  if (marginLeft == null) {
    marginLeft = marginH;
  }

  if (marginRight == null) {
    marginRight = marginH;
  }

  if (marginTop == null) {
    marginTop = marginV;
  }

  if (marginBottom == null) {
    marginBottom = marginV;
  }

  if (remove) {
    removeMargin(obj);
  }

  return {
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginTop: marginTop,
    marginBottom: marginBottom
  };
};

var extractPadding = function extractPadding(obj) {
  var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  /*
  I'm really annoyed I can't find a third-party implementation
  of this that covers edge cases...
  This eventually is useful for a React version of the SVG "padding convention"
  https://bl.ocks.org/mbostock/3019563
  */
  var paddingLeft = obj.paddingLeft,
      paddingRight = obj.paddingRight,
      paddingTop = obj.paddingTop,
      paddingBottom = obj.paddingBottom,
      paddingV = obj.paddingV,
      paddingH = obj.paddingH,
      padding = obj.padding;

  if (padding == null) {
    padding = 0;
  }

  if (paddingV == null) {
    paddingV = padding;
  }

  if (paddingH == null) {
    paddingH = padding;
  }

  if (paddingLeft == null) {
    paddingLeft = paddingH;
  }

  if (paddingRight == null) {
    paddingRight = paddingH;
  }

  if (paddingTop == null) {
    paddingTop = paddingV;
  }

  if (paddingBottom == null) {
    paddingBottom = paddingV;
  }

  if (remove) {
    removePadding(obj);
  }

  return {
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    paddingTop: paddingTop,
    paddingBottom: paddingBottom
  };
};

var expandMargin = function expandMargin(obj) {
  var margin = extractMargin(obj);

  var o1 = _objectSpread({}, obj);

  for (var _i = 0, _arr = ["margin", "marginV", "marginH"]; _i < _arr.length; _i++) {
    var key = _arr[_i];
    delete o1[key];
  }

  return _objectSpread(_objectSpread({}, o1), margin);
};

var expandPadding = function expandPadding(obj) {
  var margin = extractPadding(obj);

  var o1 = _objectSpread({}, obj);

  for (var _i2 = 0, _arr2 = ["padding", "paddingV", "paddingH"]; _i2 < _arr2.length; _i2++) {
    var key = _arr2[_i2];
    delete o1[key];
  }

  return _objectSpread(_objectSpread({}, o1), margin);
};

var expandInnerSize = function expandInnerSize(obj) {
  var n = expandPadding(obj);

  var innerHeight = n.innerHeight,
      innerWidth = n.innerWidth,
      height = n.height,
      width = n.width,
      rest = _objectWithoutProperties(n, _excluded);

  if (innerHeight != null) {
    if (n.height == null) {
      n.height = innerHeight + n.paddingTop + n.paddingBottom;
    }
  }

  if (innerWidth != null) {
    if (n.width == null) {
      n.width = innerWidth + n.paddingLeft + n.paddingRight;
    }
  }

  delete n.innerHeight;
  delete n.innerWidth;
  return n;
};

export { extractMargin, extractPadding, expandMargin, expandPadding, expandInnerSize, removeMargin, removePadding };